export function deleteMachine(data) {
    let { deleteMachineRequest, deleteMachineError, deleteMachineResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'delete_machine',
        this.createBundle('delete_machine', { machine: data }, this.POST, deleteMachineRequest, deleteMachineResult, deleteMachineError)
    )
}
